export const m9l1Solution = `%lang starknet

// Cairo hints can be useful for delegating heavy computation.
// This pattern is at the very heart of Cairo: verification is much faster than computation.
// However, as hints are not part of the final Cairo bytecode, a malicious program may provide wrong results.
// You should always verify computations done inside hints.


// TODO: Compute the result of "x modulo n" inside a hint using python's 'divmod'
// Don't forget to make sure the result is correct.
// do not modify code on this line or above

func modulo(x : felt, n : felt) -> (mod : felt) {
    alloc_locals;
    local quotient;
    local remainder;
    %{
        q, r = divmod(ids.x, ids.n)
        ids.quotient = q
        ids.remainder = r
    %}

    assert x = quotient * n + remainder;
    return (mod=remainder);
}

// do not modify code on this line or below

@external
func test_modulo{syscall_ptr : felt*}() {
    let x1 = 5;
    let n1 = 2;
    let (mod1 : felt) = modulo(x1, n1);
    assert 1 = mod1;

    let x2 = 51;
    let n2 = 7;
    let (mod2 : felt) = modulo(x2, n2);
    assert 2 = mod2;

    let x3 = 125;
    let n3 = 11;
    let (mod3 : felt) = modulo(x3, n3);
    assert 4 = mod3;

    return ();
}`;
